import { CatalogConstants } from "../constants";
import { ProofOfAddressType, WhoPaysType } from "../enums";
import { EconomicActivity, IdentificationType, LineOfBusiness, MonetaryInstrument } from "../models";
import { SubjectObligedHelper } from "./subject-obliged-helper";

export class BusinessHelper {

    // =========== VEHICLE ===============
    static approvedQuoteLabel(subjectObligedId: number, isFica: boolean) : string {
        if(isFica) {
            return "Pedido aprobado";
        } else if(SubjectObligedHelper.isSunGoCar(subjectObligedId)) {
            return "Pedido";
        }  else if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return "Documento aprobatorio de venta";
        }
        return "Cotización aprobada";
    }

    static hasApprovedQuote(subjectObligedId: number) : boolean {
        return !SubjectObligedHelper.isDemo(subjectObligedId);
    }
    static hasXmlInvoice(subjectObligedId: number) : boolean {
        return !SubjectObligedHelper.isDemo(subjectObligedId);
    }
    static hasExtraVehicleProps(subjectObligedId: number) : boolean {
        return !SubjectObligedHelper.isDemo(subjectObligedId) && !SubjectObligedHelper.isGPAutos(subjectObligedId);
    }

    static hasIsan(subjectObligedId: number, operationTypeId: number, isFica: boolean) : boolean {
        return (isFica || SubjectObligedHelper.isSunGoCar(subjectObligedId) || SubjectObligedHelper.isGPAutos(subjectObligedId))
            && operationTypeId && operationTypeId === CatalogConstants.newVehicleOperationTypeId && !SubjectObligedHelper.isDemo(subjectObligedId);
    }

    static hasRepuve(subjectObligedId: number, operationTypeId: number) : boolean {
      
        return (!SubjectObligedHelper.isGPAutos(subjectObligedId) && !SubjectObligedHelper.isDemo(subjectObligedId) )|| (
            SubjectObligedHelper.isGPAutos(subjectObligedId) &&
            operationTypeId === CatalogConstants.newVehicleOperationTypeId
        );
    }

    static hasCreditHome(isFica: boolean) : boolean {
        return isFica;
    }

    // =========== PAYMENTS ===============
    static proofOfPaymentLabel(subjectObligedId: number, whoPays: WhoPaysType): string {
        if(SubjectObligedHelper.isSunGoCar(subjectObligedId)) {
            return "Comprobante de depósito o desembolso";
        }else if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return "Comprobante de pago";
        } else {
            return "Ficha de depósito bancario";
        }
    }

    static electronicPaymentRecepitLabel(subjectObligedId: number, whoPays: WhoPaysType): string {
        if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return "REP Complemento de pago";
        } else {
            return "Recibo electrónico de pago";
        }
    }

    static getOficialIdentificationDocumentLabel(subjectObligedId: number): string {
      //[title]="'Identificación oficial' + (isGPAutos ? ' (Otra persona)' : '')"
      if(SubjectObligedHelper.isDemo(subjectObligedId))
        return "Identificación Oficial (Otro pagador)";
      else if(SubjectObligedHelper.isGPAutos(subjectObligedId))
        return "Identificación Oficial (Otra persona)";
      else
        return "Identificación Oficial";
    }

    static bankAccountStatementLabel(subjectObligedId: number, whoPays: WhoPaysType): string {
        if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return whoPays === WhoPaysType.Client ? "Estado de cuenta bancario (Cliente)" : "Estado de cuenta bancario (Otra persona)";
        } else {
            return "";
        }
    }

    static letterOfConformityLabel(subjectObligedId: number): string {
        if(SubjectObligedHelper.isSunGoCar(subjectObligedId) ||
           SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return "Carta de Cesión de Derechos";
        } else {
            return "Carta de Conformidad";
        }
    }

    static getNettingLabel(subjectObligedId: number, isFica: boolean): string {
      //isFica ? 'Activación de contrato' : isGPAutos ? 'Autorización del crédito' : 'Neteo'"
        if(SubjectObligedHelper.isDemo(subjectObligedId)) {
            return "Documento Aprobatorio Financiamiento";
        } else if(isFica) {
            return "Activación de contrato";
        } else if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return "Autorización del crédito";
        } else {
          return "Neteo";
        }
    }

    static hasDisbursementValidationDocument(subjectObligedId: number): boolean {
        return SubjectObligedHelper.isSunGoCar(subjectObligedId);
    }

    static hasTreasuryAuthorizationDocument(subjectObligedId: number): boolean {
        return SubjectObligedHelper.isSunGoCar(subjectObligedId);
    }

    static hasFinancingDropdown(subjectObligedId: number, isFica: boolean): boolean {
        return SubjectObligedHelper.isSunGoCar(subjectObligedId) || isFica || SubjectObligedHelper.isGPAutos(subjectObligedId);
    }

    static getFinancingWhoPaysValues(subjectObligedId: number, isFica: boolean){
      
      // AUTOMOTRIZ TULA DE ALLENDE
      if(subjectObligedId == 637) {
        return [
          { name: "Banco Santander México, S.A. Institución de Banca Múltiple" },
          { name: "Banco Mercantil del Norte, S.A. Institución de Banca Múltiple" },
          { name: "HSBC México, S.A. Institución de Banca Múltiple" },
          { name: "Scotiabank Inverlat, S.A. Institución de Banca Múltiple" },
          { name: "Banco Regional, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero." },
          { name: "BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México," },
          { name: "Volkswagen Leasing, S.A. de C.V." },
          
          { name: "Volkswagen Financial Services México, S.A. de C.V., SOFOM, E.N.R." },
          { name: "Auto Financiamiento Automotriz, S.A. de C.V." },
          { name: "Alsol Contigo, S.A. de C.V., SOFOM, E.N.R." },
          { name: "FINAGAM, S.C. de A.P. de R.L. de C.V." },
          { name: "Kuna Capital Services, S.A.P.I. de C.V." },
          { name: "Volkswagen Bank" }
        ];
      }
      // EUROPREMIUM SA DE CV
      // AUTO COMERCIAL POLANCO
      else if(subjectObligedId == 578 || subjectObligedId == 577) {
        return [
          { name: "Banco Santander México, S.A. Institución de Banca Múltiple" },
          { name: "Banco Mercantil del Norte, S.A. Institución de Banca Múltiple" },
          { name: "HSBC México, S.A. Institución de Banca Múltiple" },
          { name: "Scotiabank Inverlat, S.A. Institución de Banca Múltiple" },
          { name: "Banco Regional, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero." },
          { name: "BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México," },
          { name: "Volkswagen Leasing, S.A. de C.V." }
        ];
      }

      // TRES RIOS MOTORS
      else if(subjectObligedId == 638) {
        return [
          { name: "Volkswagen Leasing, S.A. de C.V." },
          { name: "AB&C Leasing de México, S.A. de C.V." },
          { name: "BBVA Leasing México, S.A. de C.V." },
          { name: "Flexia Leasing, S.A. de C.V., SOFOM, E.N.R." },
          { name: "CSI Leasing México, S.A. de C.V." },
          { name: "El Roble Arrendadora, S.A. de C.V., SOFOM, E.N.R." },
          { name: "ARRENDADORA VE POR MAS SA DE CV SOFOM, ER., GRUPO FINANCIERO VE POR MAS" },
          { name: "START BANREGIO, S.A. DE C.V. SOFOM E.R., BANREGIO GRUPO FINANCIERO" },
          { name: "Arrendadora y Factor Banorte, S.A. de C.V., Sociedad Financiera de Objeto Múltiple, Entidad Regulada, Grupo Financiero Banorte" },
          { name: "Financiera Bajío, S.A. de C.V., Sociedad Financiera de Objeto Múltiple, Entidad Regulada, Grupo Financiero BanBajío" },
          { name: "Active Leasing, S.A. de C.V., SOFOM, E.N.R." },
          { name: "GE Capital México, S.A. de C.V." },
          { name: "Audi Financial Services México, S.A. de C.V., Sociedad Financiera de Objeto Múltiple, Entidad Regulada (SOFOM, E.R.)." },
          { name: "Volkswagen Financial Services México, S.A. de C.V., Sociedad Financiera de Objeto Múltiple, Entidad Regulada (SOFOM, E.R.)." },
          { name: "Banco Santander México, S.A. Institución de Banca Múltiple" },
          { name: "Banco Mercantil del Norte, S.A. Institución de Banca Múltiple" },
          { name: "HSBC México, S.A. Institución de Banca Múltiple" },
          { name: "Scotiabank Inverlat, S.A. Institución de Banca Múltiple" },
          { name: "Banco Regional, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero." },
          { name: "BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México," }
        ];
      }

      // EURO CITY SA DE CV
      else if(subjectObligedId == 645) {
        return [
          { name: "Volkswagen Leasing, S.A. de C.V." },
          { name: "BBVA Leasing, S.A. de C.V." },
          { name: "ARRENDADORA VE POR MÁS, S.A. DE C.V., SOFOM, E.R., GRUPO FINANCIERO VE POR MÁS Grupo" },
          { name: "Arrendadora Ve Por Más, S.A. de C.V., SOFOM, E.R., Grupo Financiero Ve Por Más" },
          { name: "AB&C Leasing de México, S.A." },
          { name: "Start Banregio, S.A. de C.V., Sociedad Financiera de Objeto Múltiple, Entidad Regulada, Banregio" },
          { name: "Arrendadora Afirme, S.A. de C.V., SOFOM, E.R.," },
          { name: "Financiera Premier, S.A. de C.V., SOFOM, E.R." },
          { name: "Financiera Bajío, S.A. de C.V., SOFOM, E.R." },
          { name: "Banco Santander México, S.A. Institución de Banca Múltiple" },
          { name: "Banco Mercantil del Norte, S.A. Institución de Banca Múltiple" },
          { name: "HSBC México, S.A. Institución de Banca Múltiple" },
          { name: "Scotiabank Inverlat, S.A. Institución de Banca Múltiple" },
          { name: "Banco Regional, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero." },
          { name: "BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México," },
          { name: "Kuna Capital Services, S.A.P.I. De C.V."}
        ];
      }

      // AUTO COMERCIAL INTERLOMAS
      // AUTO COMERCIAL SANTA FE
      else if(subjectObligedId == 653 || subjectObligedId == 652) {
        return [
          { name: "Ford Credit de México, S.A. de C.V., Sociedad Financiera de Objeto Múltiple, Entidad Regulada (SOFOM, E.R.)." },
          { name: "Banco Santander México, S.A. Institución de Banca Múltiple" },
          { name: "Banco Mercantil del Norte, S.A. Institución de Banca Múltiple" },
          { name: "HSBC México, S.A. Institución de Banca Múltiple" },
          { name: "Scotiabank Inverlat, S.A. Institución de Banca Múltiple" },
          { name: "Banco Regional, S.A., Institución de Banca Múltiple, Banregio Grupo Financiero." },
          { name: "BBVA México, S.A., Institución de Banca Múltiple, Grupo Financiero BBVA México," }
        ];
      }

      // AUTOCAR SANTA FE SA DE CV
      // AUTOMOBILE SANTA FE SA DE CV
      else if(subjectObligedId == 678 || subjectObligedId == 679) {
        return [
          { name: "AB&C Leasing De México, S.A. De C.V." },
          { name: "Active Leasing, S.A. De C.V., SOFOM, E.N.R." },
          { name: "Arrendadora Ve Por Mas, S.A. De C.V., SOFOM, E.R., Grupo Financiero Ve Por Mas" },
          { name: "Arrendadora Y Factor Banorte, S.A. De C.V., SOFOM, E.R., Grupo Financiero Banorte" },
          { name: "Banco Mercantil Del Norte, S.A., Institución De Banca Múltiple" },
          { name: "Banco Regional, S.A., Institución De Banca Múltiple, Banregio Grupo Financiero" },
          { name: "Banco Santander México, S.A., Institución De Banca Múltiple" },
          { name: "BBVA Consumer Finance, S.A. De C.V., SOFOM, E.R." },
          { name: "BBVA Leasing México, S.A. De C.V." },
          { name: "BBVA México, S.A., Institución De Banca Múltiple, Grupo Financiero BBVA México" },
          { name: "Cetelem, S.A. De C.V., SOFOM, E.R." },
          { name: "CSI Leasing México, S.A. De C.V." },
          { name: "El Roble Arrendadora, S.A. De C.V., SOFOM, E.N.R." },
          { name: "Financiera Bajío, S.A. De C.V., SOFOM, E.R." },
          { name: "Flexia Leasing, S.A. De C.V., SOFOM, E.N.R." },
          { name: "GE Capital México, S.A. De C.V." },
          { name: "HSBC México, S.A., Institución De Banca Múltiple" },
          { name: "Kuna Capital Services, S.A.P.I. De C.V." },
          { name: "NR Finance México, S.A. De C.V." },
          { name: "Scotiabank Inverlat, S.A., Institución De Banca Múltiple" },
          { name: "Start Banregio, S.A. De C.V., SOFOM, E.R., Banregio Grupo Financiero" }
        ];
      }
      
      else if(isFica) {
            return [
                {name: "VOLKSWAGEN LEASING, S.A. DE C.V."},
                {name: "VOLKSWAGEN BANK, S.A. INSTITUCIÓN DE BANCA MÚLTIPLE"},
                {name: "FICA MOTORS"},
                {name: "AUTO FINANCIAMIENTO, S.A. (AFASA)"},
              ];
        }

        else if(SubjectObligedHelper.isSunGoCar(subjectObligedId)) {
            return [
                {name: "BBVA"},
                {name: "BANORTE"},
                {name: "SANTANDER"},
                {name: "NEXU"},
                {name: "CI BANCO"},
                {name: "AFIRME"},
                {name: "BANREGIO"},
                {name: "HSBC"},
                {name: "FIRMACAR"},
                {name: "CETELEM"},
                {name: "HONDA FINANCIAL"}
              ];
        } else if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return [
                {name: "VOLKSWAGEN LEASING (VWL)"},
                {name: "VOLKSWAGEN BANK (VWB)"},
                {name: "BANCOS"},
              ];
        }

        return [];
    }

    // =========== CLIENTS ===============

    /// --- CLIENT/BENEFICIARY FORMS
    static filterEconomicActivitiesBySubjectObliged(items: EconomicActivity[] | LineOfBusiness[], subjectObligedId: number) {
        if(SubjectObligedHelper.isSunGoCar(subjectObligedId))
            return items.filter(i => i.id !== 1); // Removes NO APLICA option
        else
            return items;
    }

    /// --- IDENTIFICATION MODAL
    static filterIdentificationTypesBySubjectObliged(items: IdentificationType[], subjectObligedId: number) {

        let validIds: number[] = [1, 2, 11];
        if(SubjectObligedHelper.isSunGoCar(subjectObligedId)) {
            return items.filter(i => validIds.includes(i.id)).map(i => {
                if(i.id === 1)
                    return {...i, name: "Credencial para Votar"}; // Renames INE o IFE option
                else
                    return i;
            });
        }
        else {
            return items.filter(i => i.id !== 11);
        }
    }

    /// --- INSTRUMENTO MONETARIO
    static filterMonetaryInstrumentsBySubjectObliged(items: MonetaryInstrument[], subjectObligedId: number) {

        let invalid: number[] = [7, 12, 13, 14, 15, 16];
        if(SubjectObligedHelper.isGPAutos(subjectObligedId)) {
            return items.filter(i => !invalid.includes(i.id)).map(i => {
              return i;
            });
        }

        return items;
    }

    /// --- PROOF OF ADDRESS
    static getProofAddressTypesBySubjectObliged(subjectObligedId: number) {
        const items = ProofOfAddressType.items();
        if(SubjectObligedHelper.isSunGoCar(subjectObligedId)) {
            const validItems = [
                ProofOfAddressType.Light,
                ProofOfAddressType.Water,
                ProofOfAddressType.Telephone,
                ProofOfAddressType.BankStatement,
                ProofOfAddressType.INE
            ];

            return items.filter(i => validItems.includes(i.value)).map(i => {
                if(i.value === ProofOfAddressType.Telephone)
                    return {...i, key: "Telefonía Fija"}; // Telmex, Easy, Totalplay, Megacable
                else if(i.value === ProofOfAddressType.INE)
                    return {...i, key: "Credencial para Votar"}; // Renames INE
                else
                    return i;
            });
        }
        else {
            return items;
        }
    }
}
